import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		cases: [
			{
				title: "Delta",
				slug: "delta",
				link: "http://ihealthdelta.com",
				date: "2021",
				maxScreens: 7,
				text: "Site for medical center",
				objective:
					"Provide services & doctors list to a customers with the possibility of ordering, required SSR for SEO"
			},
			{
				title: "Digital History",
				slug: "dighis",
				link: "https://digital-history.ru",
				date: "2020",
				maxScreens: 7,
				text: "Frontend for historical community",
				objective: "To post an information about the nearest and past events"
			},
			{
				title: "NorthEast Xpress",
				slug: "northeast",
				link: "https://northeastxpress.com",
				date: "2020",
				maxScreens: 3,
				text: "SPA for freight company",
				objective:
					"To grab and save truck driver's personal information for employment"
			},
			{
				title: "Boosting tavern",
				slug: "btavern",
				link: "https://boostingtavern.com",
				date: "2019",
				maxScreens: 3,
				text: "Frontend for boosting service",
				objective:
					"Let to a user book services for boosting his character in WoW"
			},
			{
				title: "Ownbot",
				slug: "ownbot",
				link: "https://ownbots.ru",
				date: "2018",
				maxScreens: 7,
				text: "Frontend for bots platform",
				objective: "Provide multiple bots management in one dashboard"
			}
		],
		contacts: [
			{
				title: "sunpacker@ya.ru",
				link: "mailto:sunpacker@yandex.ru",
				icon: "fa fa-envelope"
			},
			{
				title: "https://github.com/Sunpacker",
				link: "https://github.com/Sunpacker",
				icon: "fa fa-github"
			},
			{
				title: "https://t.me/Sunpacker",
				link: "https://t.me/Sunpacker",
				icon: "fa fa-telegram"
			},
			{
				title: "https://vk.com/sunpacker",
				link: "https://vk.com/sunpacker",
				icon: "fa fa-vk"
			}
		]
	}
});
